import { Link } from "react-router-dom";

const HomeComponent = () => {
  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Link to="/table">
        <button>Table</button>
      </Link>
      <Link to="/table2">
        <button>Table2</button>
      </Link>
      <Link to="/table3">
        <button>Table3</button>
      </Link>
      <Link to="/editableinput">
        <button>Editable</button>
      </Link>
      <Link to="/drawing">
        <button>Drawing</button>
      </Link>
      <Link to="/location">
        <button>Location</button>
      </Link>
      <Link to="/camera">
        <button>Camera</button>
      </Link>
    </div>
  );
};

export default HomeComponent;
